// Tokens del flujo PLR rediseñado (canvas "flujo": 1f → 2g → 3f → 4f / 4fb / 4fc).
// Mantener alineado con el canvas de diseño; no usar los colores del partner
// para botones o textos: el flujo es white-label solo por logo y foto.
export const plr = {
  ink: '#291D5E',
  inkHover: '#6052A1',
  accent: '#4a38a0',
  chip: '#ECE8F4',
  body: '#4F4F63',
  muted: '#6B6B80',
  faint: '#8A8A9C',
  border: '#E0E0E0',
  surface: '#F4F6F9',
  // Fondo detrás del panel de la imagen en desktop (la columna del formulario es blanca).
  page: '#F5F3FA',
  divider: '#E9E5F2',
  panel: '#EDEBF3',
  hero: '#332675',
  heroText: '#DCD5F7',
  heroLabel: '#B9AEE8',
  mint: '#99FF99',
  mintInk: '#022c22',
  danger: '#9B1C1C',
  stepDone: '#291D5E',
  stepCurrent: '#6052A1',
  stepTodo: '#ECE8F4',
  gradient: 'linear-gradient(140deg, #F4F0FE 0%, #E4DBFB 100%)',
  stripes: 'repeating-linear-gradient(135deg, #7A66DB 0 5px, #A898EE 5px 10px)',
  overlay: 'rgba(26,20,61,0.45)',
  font: "'Inter PLR', Inter, Helvetica, Arial, sans-serif",
} as const;

// Escritorio o tablet con poca altura (notebooks de 768–900 px con la barra del navegador): la
// card se compacta (márgenes, header, títulos, botones) para reducir el scroll.
export const SHORT_DESKTOP = '@media (min-width: 600px) and (max-height: 860px)';

// Ancho a partir del cual se muestra el panel del proyecto (igual que el canvas).
export const PANEL_BREAKPOINT = 'lg' as const;
